import 'slick-carousel'
import 'slick-lightbox'
import MultiselectDropdown from '@js/custom/multiselect.js'
import Plyr from 'plyr'
import Cookies from 'js-cookie'
import moment from 'moment'
import { gsap, Power4 } from 'gsap'

function customSlickCloneActive(_self) {
    _self.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        const slideCount = slick.slideCount
        const $cloneSlides = _self.find('.slick-slide.slick-cloned')
        $cloneSlides.removeClass('slick-clone-current')
        const cloneIndex = nextSlide + slideCount

        $cloneSlides.each(function () {
            if ($(this).data('slick-index') === cloneIndex) {
                $(this).addClass('slick-clone-current')
            }
        })

        if (nextSlide === slideCount - 1) {
            _self.find('.slick-slide[data-slick-index="-1"]').addClass('slick-clone-current')
        }
    })
}


const digistormWeb = {
    init() {
        // helper for iOS issues
        this.iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)

        // load nav
        this.nav()

        // load tabs
        this.tabs()
        this.accordions()

        // load videos
        this.videos.init()

        // load carousel
        this.slick()
        this.banners()
        this.video_modal()

        this.forms()

        this.popups()
        this.analytics()

        this.employment()

        // this.newsletters()

        this.entryScreen()

        this.socialFeeds()
        // this.newsletterBackToTop()

        this.wowo()
        this.stickyMenu()
        this.navbar()
        this.search()

        this.userback()
    },

    newsletterBackToTop() {
        $('.back-top').on('click', () => {
            $('#main').scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            })
        })
    },

    socialFeeds() {
        $('section.social-block').each(function () {
            // console.log("requesting social posts...");
            const socialWrapper = $(this).find('.social-wrapper')

            //   this is the toggle for individual social blocks
            const facebookToggle = $(this).attr('data-facebook') === '1'
            const instagramToggle = $(this).attr('data-instagram') === '1'
            const limit = 8

            const svgMap = {
                facebook:
                    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512"><path d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"/></svg>',
                instagram:
                    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>',
            }

            $.ajax({
                url: '/api/socialfeed/request-posts',
                data: {
                    facebook: facebookToggle,
                    instagram: instagramToggle,
                    limit,
                },
                dataType: 'json',
                success(posts) {
                    // console.log("...successfully fetched social posts");
                    let postHtml = ''

                    $.each(posts, (index, post) => {
                        const postDescription =
                            post.description.length > 200
                                ? `${post.description.substring(0, 199).trim()}...`
                                : post.description
                        const date = new Date(post.created * 1000).toLocaleDateString()

                        let iconSvg = ''
                        if (post.type in svgMap) {
                            iconSvg = svgMap[post.type]
                        }

                        // append post html
                        postHtml += `<a href="${post.link}" class="item item--social" target="_blank"><div class="img"><div class="responsive-img"><img src="${post.image}" /></div></div><div class="text"><span class="social-icon">${iconSvg}</span><p>${postDescription}</p></div></a>`
                    })

                    // render posts on page
                    socialWrapper.html(postHtml)

                    socialWrapper.slick({
                        dots: false,
                        arrows: false,
                        infinite: true,
                        speed: 500,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: true,
                        adaptiveHeight: false,
                        fade: false,
                        autoplaySpeed: 5000,
                        pauseOnHover: false,
                        pauseOnFocus: false,
                        focusOnSelect: false,
                        draggable: false,
                    })
                },
            }).fail(() => {
                console.log('...failed fetching social posts')
                socialWrapper
                    .find('.socials-loading')
                    .html('<h5>Something went wrong when fetching social feed.<br>Please try again later!</h5>')
            })
        })

        $('.happening-panel .panel--social').each(function () {
            // console.log("requesting social posts...");
            const socialWrapper = $(this).find('.items')

            //   this is the toggle for individual social blocks
            const facebookToggle = $(this).attr('data-facebook') === '1'
            const instagramToggle = $(this).attr('data-instagram') === '1'
            const limit = 8

            const svgMap = {
                facebook:
                    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512"><path d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"/></svg>',
                instagram:
                    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>',
            }

            $.ajax({
                url: '/api/socialfeed/request-posts',
                data: {
                    facebook: facebookToggle,
                    instagram: instagramToggle,
                    limit,
                },
                dataType: 'json',
                success(posts) {
                    // console.log("...successfully fetched social posts");
                    let postHtml = ''

                    $.each(posts, (index, post) => {
                        const postDescription =
                            post.description.length > 200
                                ? `${post.description.substring(0, 199).trim()}...`
                                : post.description
                        const date = new Date(post.created * 1000).toLocaleDateString()

                        let iconSvg = ''
                        if (post.type in svgMap) {
                            iconSvg = svgMap[post.type]
                        }

                        // append post html
                        postHtml += `
                        <a href="${post.link}" class="item item--social" target="_blank">
                            <div class="img">
                                <div class="responsive-img"><img src="${post.image}" /></div>
                                <span class="social-icon">${iconSvg}</span>
                            </div>
                        </a>`
                    })

                    // render posts on page
                    socialWrapper.html(postHtml)
                },
            }).fail(() => {
                console.log('...failed fetching social posts')
                socialWrapper
                    .find('.socials-loading')
                    .html('<h5>Something went wrong when fetching social feed.<br>Please try again later!</h5>')
            })
        })
    },

    // entryScreen() {
    //     const es = $('.entry-screen')
    //     const key = 'entryScreen'
    //     const cookie = Cookies.get(key)
    //     const slick = $('.es-overlay')

    //     if (slick.length > 0) {
    //         slick.slick({
    //             dots: slick.find('.slick-slide').length > 1,
    //             // dots: false,
    //             arrows: false,
    //             infinite: true, // loop
    //             fade: true,
    //             cssEase: 'none',
    //             speed: 500,
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //             autoplay: false,
    //             autoplaySpeed: 1000,
    //             pauseOnHover: false,
    //             pauseOnFocus: false,
    //             focusOnSelect: false,
    //             draggable: false,
    //             // lazyLoad: 'anticipated',
    //         })

    //         slick.on('init afterChange', (event, slickElement, currentSlide) => {
    //             if (currentSlide === slickElement.slideCount - 1) {
    //                 slick.slick('slickPause')

    //                 setTimeout(() => {
    //                     Cookies.set(key, 'viewed', {
    //                         expires: 1,
    //                     })
    //                     es.addClass('is-top')
    //                     $('html').css('overflow', '')
    //                     digistormWeb.wowo()
    //                 }, 1000)
    //             }
    //         })

    //         if (cookie) {
    //             es.addClass('is-top')
    //             digistormWeb.wowo()
    //         } else {
    //             es.removeClass('delete')
    //             $('body,html').animate(
    //                 {
    //                     scrollTop: 0,
    //                 },
    //                 0
    //             )
    //             $('html').css('overflow', 'hidden')
    //             setTimeout(() => {
    //                 $('body,html').animate(
    //                     {
    //                         scrollTop: 0,
    //                     },
    //                     0
    //                 )
    //                 slick.slick('slickPlay')
    //             }, 1000)
    //         }
    //     } else {
    //         digistormWeb.wowo()
    //     }
    // },

    entryScreen() {
        const es = $('.entry-screen')
        const btn = $('.entry-screen #entry-screen-btn')
        const key = 'entryScreen'

        const cookie = Cookies.get(key)
        if (!cookie) {
            es.addClass('active')
            setTimeout(() => {
                Cookies.set(key, 'viewed', {
                    expires: 1,
                })
                $('.page-wrapper').css('opacity', '')
                es.addClass('is-top')
            }, 2500)
        } else {
            $('.page-wrapper').css('opacity', '')
        }
    },

    banners() {
        const banner = $('.banner--home.image-carousel .slick-content')
        if (banner.length > 0) {
            const _parent = banner.parent()
            const $controlwrapper = _parent.find('.slick-bottom')
            const $dotswrapper = $controlwrapper.find('.slick-dots-wrapper')
            const slickLength = banner.find('.banner-inner').length
            banner.on('init', () => {
                if (slickLength > 1) {
                    $controlwrapper.find('.slick-arrow').show()
                    console.log('has slickLength')
                }
                $controlwrapper.find('.slick-prev').on('click', () => {
                    banner.slick('slickPrev')
                    console.log('slickPrev')
                })
                $controlwrapper.find('.slick-next').on('click', () => {
                    banner.slick('slickNext')
                    console.log('slickNext')
                })
            })
            banner.slick({
                dots: slickLength > 1,
                appendDots: $dotswrapper,
                arrows: false,
                infinite: true, // loop
                speed: 1000,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 10000,
                focusOnSelect: true,
                pauseOnHover: false, // mouse hover
                lazyLoad: 'anticipated',
            })
            banner.removeClass('init')
        }
    },

    nav() {
        // find any navbar burger buttons
        $('.navigation')
            .find('.navbar-burger')
            .click(function (e) {
                e.preventDefault()

                // find specified navbar
                const target = $(this).attr('data-target')

                if (target.length) {
                    // toggle active class on burger button
                    $('.navbar-burger').toggleClass('is-active')

                    // toggle active class on specified menu
                    $(`#${target}`).toggleClass('is-active')

                    if (!$(this).hasClass('is-active')) {
                        $('.top-level-item.has-children.is-active').removeClass('is-active')
                    }
                }
            })

               // top level desktop
        $('.navbar-menu .top-level-item .item-wrapper').bind('mouseenter mouseleave', function () {
            if ($(window).width() >= 1024) {
                const parent = $(this).closest('.top-level-item')
                parent.addClass('is-active').siblings('.top-level-item').removeClass('is-active')
            }
        })

        window.addEventListener('resize', () => {
            if ($(window).width() < 1024) {
                $('.top-level-item').removeClass('is-active')
                $('body').removeClass('submenu-open')
            }
        })

        // top level mobile
        $('.navbar-menu .top-level-item .item-wrapper').bind('keyup', function () {
            const parent = $(this).closest('.top-level-item')
            parent.addClass('is-active').siblings('.top-level-item').removeClass('is-active')
            if ($(window).width() < 1024) {
                $('body').addClass('submenu-open')
            }
        })
        $('.navbar-menu .top-level-item .item-wrapper').on('click', function () {
            if ($(window).width() < 1024) {
                const parent = $(this).closest('.top-level-item')
                parent.addClass('is-active').siblings('.top-level-item').removeClass('is-active')
                $('body').addClass('submenu-open')
            }
        })
        $('.navbar-menu .children-panel .subpage-close').on('click', () => {
            $('.top-level-item.has-children.is-active').removeClass('is-active')
            $('body').removeClass('submenu-open')
        })
        $('.navbar-menu .top-level-item.has-children, .navbar-menu .child-item.has-third').on('click', function () {
            const parent = $(this).closest('.child-item')
            const dropdown = parent.find('.third-panel')
            parent.toggleClass('is-active').siblings('.child-item').removeClass('is-active')

            dropdown.slideToggle(250)
            parent.siblings('.child-item').find('.third-panel').slideUp(250)
        })

        $(
            '.navbar-menu .top-level-item.has-children .item-wrapper a, .navbar-menu .child-item.has-third .child-title a'
        ).on('click', (e) => {
            e.preventDefault()
        })
        $('.navbar-menu .child-item.has-third .third-item a').on('click', (e) => {
            e.stopPropagation()
        })

        $('.quicklinks .link-title').on('click', function () {
            const parent = $(this).parent('.quicklinks')
            parent.toggleClass('is-active')

            if (parent.hasClass('is-active')) {
                setTimeout(() => {
                    parent[0].scrollIntoView({
                        behavior: 'smooth',
                        block: 'end',
                    })
                }, 500)
            }
        })

        $('.side-quicklinks').on('click', function () {
            $(this).toggleClass('is-active')
            $('#side-quicklinks-close').toggleClass('is-active')
        })

        $('#side-quicklinks-close').on('click', function () {
            $(this).toggleClass('is-active')
            $('.side-quicklinks').toggleClass('is-active')
        })

        // find any navbar search buttons
        // $('.navigation .search-trigger').click(function (e) {
        //     e.preventDefault()
        //
        //     // find specified navbar
        //     const target = $(this).attr('data-target')
        //
        //     if (target.length) {
        //         // toggle active class on specified element
        //         $(`#${ target}`).toggleClass('is-active')
        //
        //         if ($(`#${ target}`).is('.is-active')) {
        //             $('input.search').focus()
        //         } else {
        //             $('input.search').blur()
        //         }
        //     }
        // })
    },

    video_modal() {
        $('.play-video-btn').on('click', function (e) {
            e.preventDefault()
            const modalId = $(this).attr('data-modal-id')
            const modal = $(`#${modalId}`)

            if (!modal) {
                return
            }

            const videoPlayer = modal.find('.video-player')
            if (!videoPlayer) {
                return
            }
            if (!videoPlayer.hasClass('plyr-loaded')) {
                digistormWeb.videos.loadVideoModal(videoPlayer[0])
            } else {
                const settings = JSON.parse(videoPlayer.attr('data-settings'))
                digistormWeb.videos.playVideo(videoPlayer, settings.volume, settings.muted)
            }

            modal.addClass('is-active')
        })

        $('.video-modal .modal-background').click(function () {
            const $modal = $(this).closest('.video-modal')
            $modal.removeClass('is-active')
            if (digistormWeb.iOS) {
                digistormWeb.videos.stopVideo($modal.find('.video-player'))
            } else {
                digistormWeb.videos.pauseVideo($modal.find('.video-player'))
            }
        })

        $('.video-modal .close-button').click(function (e) {
            e.preventDefault()
            const $modal = $(this).closest('.video-modal')
            $modal.removeClass('is-active')
            digistormWeb.videos.stopVideo($modal.find('.video-player'))
        })
    },

    videos: {
        init() {
            const _self = this

            // check if there is a video player wrapper

            if ($('.video-player.banner-video').length) {
                $('.video-player.banner-video').each(function () {
                    _self.loadVideo(this)
                })
            }

            _self.controls()
            _self.carousel()
        },

        controls() {
            // initialise video controls

            $('.video-carousel .banner .control-pause').click(function () {
                const $player = $(this).closest('.banner').find('.video-player')
                switch (digistormWeb.videos.togglePlay($player)) {
                    case 'no-data':
                        break
                    case true:
                        $(this).removeClass('fa-play').addClass('fa-pause')
                        break
                    case false:
                        $(this).removeClass('fa-pause').addClass('fa-play')
                        break
                }
            })

            $('.video-carousel .banner .control-vol').click(function () {
                const $player = $(this).closest('.banner').find('.video-player')
                switch (digistormWeb.videos.toggleMute($player)) {
                    case 'no-data':
                        break
                    case true:
                        $(this).removeClass('fa-volume-off').addClass('fa-volume-up')
                        break
                    case false:
                        $(this).removeClass('fa-volume-up').addClass('fa-volume-off')
                        break
                }
            })
        },

        carousel() {
            // handle videos inside slick carousels
            $('.video-carousel')
                .on('init', (event, slick) => {
                    // mark carousel as initialized
                    slick.is_initialized = true
                })
                .on('setPosition', (event, slick) => {
                    // synchronize slides with videos

                    if (slick.is_initialized) {
                        // the slide up next
                        const $newSlide = $(slick.$slides[slick.currentSlide])

                        // pause others
                        $newSlide
                            .closest('.video-carousel')
                            .find('.banner')
                            .not($newSlide)
                            .find('.video-player')
                            .each((i, e) => {
                                if (digistormWeb.iOS) {
                                    // currently there's a bug with plyr where pause won't work on iOS
                                    digistormWeb.videos.stopVideo($(e))
                                } else {
                                    digistormWeb.videos.pauseVideo($(e))
                                }
                            })

                        // play new slide
                        const video = $newSlide.find('.video-player')
                        digistormWeb.videos.playVideo(video)
                        if (video.data() && video.data().player) {
                            // This slide is a video, pause slick autoslide
                            slick.$slider.slick('slickPause')
                        } else {
                            // This slide is not a video, resume slick autoslide
                            slick.$slider.slick('slickPlay')
                            $('.circleProgress').css('animation-duration', `${5.9}s`)
                        }
                    }
                })
        },

        loadVideo(el) {
            // load a video element

            // get each config attr from this element
            const settings = JSON.parse($(el).attr('data-settings'))

            // grab player elements
            const player = $(el).find('.player')

            const plyr = new Plyr(player[0], settings)
            // set up each video
            $(el).data({
                player: plyr,
            })

            // if a carousel video, go to the next slide on video end
            const $carousel = $(el).closest('.video-carousel')
            if ($carousel.length) {
                if (plyr.source && plyr.source.indexOf('youtube') >= 0) {
                    // youtube loop doesn't work, manually detect end of video
                    plyr.on('timeupdate', (event) => {
                        if (plyr.currentTime >= plyr.duration - 0.1) {
                            plyr.restart()
                            if ($carousel.find('.banner').length > 1) {
                                $carousel.slick('slickNext')
                            }
                        }
                    })
                } else {
                    // on loop, go to the next slide
                    plyr.on('seeked', (event) => {
                        $carousel.slick('slickNext')
                    })
                }

                plyr.on('playing', () => {
                    $(el).closest('.banner').find('.control-pause').removeClass('fa-play').addClass('fa-pause')
                })
                plyr.on('pause', () => {
                    $(el).closest('.banner').find('.control-pause').removeClass('fa-play').addClass('fa-pause')
                })
            }

            if (settings.muted && settings.autoplay) {
                digistormWeb.videos.attemptPlay(plyr)
            }
        },

        loadVideoModal(el) {
            // console.log("loading video now");

            // get each config attr from this element
            const settings = JSON.parse($(el).attr('data-settings'))

            // grab player elements
            const player = $(el).find('.player')

            const plyr = new Plyr(player[0], settings)

            // set up each video
            $(el).data({
                player: plyr,
            })

            digistormWeb.videos.attemptPlay(plyr, settings.volume, settings.muted)

            $(el).addClass('plyr-loaded')
        },

        attemptPlay(player, volume = 0, muted = true, count = 0) {
            // attempts to play the video multiple times in case element is still loading

            player.volume = volume
            player.muted = muted
            player.play()
            if (count < 15 && !player.playing) {
                setTimeout(() => {
                    count++
                    digistormWeb.videos.attemptPlay(player, volume, muted, count)
                }, 1000)
            }
        },

        playVideo($el, volume = 0, muted = 1) {
            if ($el.data() && $el.data().player) {
                // enable ability to play unmuted
                $el.data().player.volume = volume
                $el.data().player.muted = muted
                $el.data().player.play()
            }
        },
        pauseVideo($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.pause()
            }
        },
        stopVideo($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.stop()
            }
        },
        togglePlay($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.togglePlay()
                return $el.data().player.playing
            }
            return 'no-data'
        },
        toggleMute($el) {
            if ($el.data() && $el.data().player) {
                const player = $el.data().player
                if (player.volume === 0) {
                    player.volume = 1
                    return true
                }
                player.volume = 0
                return false
            }
            return 'no-data'
        },
    },

    slick() {
        $('.home-banners').each(function () {
            const $dotswrapper = $(this).parent().find('.slick-dots-wrapper .container')
            const $slickElement = $(this)
            $slickElement.slick({
                arrows: false,
                dots: false,
            })
        })

        // load basic slick on all basic slicks
        $('.gallery.is-carousel').each(function () {
            const _self = $(this)
            const $dotswrapper = $(this).find('.slick-dots-wrapper')
            _self.find('.slick').on('init', () => {
                if (_self.find('.slick-slide').length > 1) {
                    _self.find('.slick-arrow').show()
                }
                _self.find('.slick-prev').on('click', () => {
                    _self.find('.slick').slick('slickPrev')
                })
                _self.find('.slick-next').on('click', () => {
                    _self.find('.slick').slick('slickNext')
                })
            })
            _self.find('.slick').slick({
                dots: true,
                arrows: false,
                infinite: false,
                appendDots: $dotswrapper,
            })
        })

        // lightbox config
        $('.gallery.is-carousel')
            .find('.slick')
            .slickLightbox({
                src: 'src',
                itemSelector: 'img',
                caption: 'caption',
                layouts: {
                    closeButton:
                        '<button class="close-modal close-button"> <span></span> <span></span> <span></span> </button>',
                },
            })

        const galleryLightbox = $('.gallery.is-lightbox')
            .find('ul')
            .slickLightbox({
                itemSelector: '> li > a',
                caption: 'caption',
                layouts: {
                    closeButton:
                        '<button class="close-modal close-button"> <span></span> <span></span> <span></span> </button>',
                },
            })
        galleryLightbox.on({
            'show.slickLightbox': function () {
                digistormWeb.lockBg()
            },
            'shown.slickLightbox': function () {
                // fired when the lightbox is opened, after the transitions took place
            },
            'hide.slickLightbox': function () {
                // fired when the lightbox is closed
                digistormWeb.unlockBg()
            },
            'hidden.slickLightbox': function () {
                // fired when the lightbox is closed, after the transitions took place
            },
        })

        $('.gallery.is-lightbox .more-s').click(function (e) {
            e.preventDefault()
            $(this).closest('.is-lightbox').find('.is-hidden:first a').click()
        })
    },

    tabs() {
        const _self = this

        // transform tabs into work of magic
        $('.tabs')
            .find('.tab-title')
            .click(function () {
                // get the relative tabs
                const $tabs = $(this).closest('.tabs')
                const activeIndex = $(this).index()

                // remove active class from all tabs
                $tabs.find('.tab-title').removeClass('is-active')
                $tabs.find('.tab-content').removeClass('is-active')

                // add active to current tab
                $(this).addClass('is-active')
                $tabs.find('.tab-content').eq(activeIndex).addClass('is-active')
            })
    },

    accordions() {
        // accordions
        $('.style-accordion .accordion-header').on('click', function () {
            const me = $(this)
            const $wrapper = me.closest('.accordion-wrapper')
            const $content = me.next('.accordion-content')
            const wasActive = $wrapper.hasClass('is-active')
            const $otherWrapper = $wrapper.siblings()
            if (wasActive) {
                $wrapper.removeClass('is-active')
                $content.stop().slideUp(250)
            } else {
                $wrapper.addClass('is-active')
                $content.stop().slideDown(250)
                $otherWrapper.removeClass('is-active').find('.accordion-content').slideUp(250)
            }
        })
    },

    forms() {
        // Send google analytics event on form submission
        $('[data-form-name] form').submit(function () {
            const formWrapper = $(this).closest('[data-form-name]')
            if (window.ga) {
                ga('send', 'event', formWrapper.attr('data-form-name'), formWrapper.attr('data-form-page'))
            }
        })
    },

    popups() {
        $('.action-modal').each(function () {
            const modal = $(this)
            const key = `modal-${modal.data('key')}`
            const cookie = Cookies.get(key)

            if (!cookie) {
                modal.addClass('active')
                $('#ds-vue-wrapper').addClass('action-modal-active')

                modal.find('.close-action-modal').click(() => {
                    modal.addClass('delete')
                    modal.removeClass('active')
                    $('#ds-vue-wrapper').removeClass('action-modal-active')
                    Cookies.set(key, 'viewed', {
                        expires: 5,
                    })
                })
                modal.find('.action-modal-background').click(() => {
                    modal.removeClass('active')
                })
            }
        })

        $('.alert-bar').each(function () {
            const modal = $(this)
            const key = `modal-${modal.data('key')}`
            const cookie = Cookies.get(key)

            if (!cookie) {
                modal.addClass('active')
                $('#ds-vue-wrapper').addClass('alert-bar-active').css('margin-top', $('.alert-bar').height())
                // $('.navbar.main-navbar,.side-quicklinks').css("margin-top", $(".alert-bar").height());

                $(window).on('resize', () => {
                    if ($('.alert-bar').hasClass('active')) {
                        $('#ds-vue-wrapper').addClass('alert-bar-active').css('margin-top', $('.alert-bar').height())
                        // $('.navbar.main-navbar,.side-quicklinks').css("margin-top", $(".alert-bar").height());
                    }
                })

                modal.find('.close-alert-bar').click(() => {
                    modal.addClass('delete')
                    $('#ds-vue-wrapper').removeClass('alert-bar-active').css('margin-top', '0')
                    // $('.navbar.main-navbar,.side-quicklinks').css("margin-top", "");
                    Cookies.set(key, 'viewed', {
                        expires: 5,
                    })
                    setTimeout(() => {
                        modal.removeClass('active')
                    }, 300)
                })
                modal.find('.alert-bar-background').click(() => {
                    modal.removeClass('active')
                })
            }
        })
    },

    analytics() {
        // Track clicks on external links
        $('body').on('click', 'a[href]', function (e) {
            const domain = String(window.location.host).replace(/^www\./, '')
            const openInNewWindow = $(this).attr('target') === '_blank'
            const url = $(this).attr('href')

            // Find the domain of the link. Works with http, https and protocol-less urls
            const linkAnatomy = url.match(/^(https?:)?\/\/(www\.)?([^/\s]+)/)
            if (linkAnatomy) {
                const linkDomain = linkAnatomy[3]

                // Check if google analytics is loaded and the url is external
                if (window.ga && domain !== linkDomain) {
                    ga('send', 'event', 'Navigation', 'Open URL', url)

                    // If the link will open in this window we should delay navigation until the event is sent
                    if (!openInNewWindow && !e.isDefaultPrevented()) {
                        e.preventDefault()

                        // Push the navigation onto the queue (will be processed after event is sent)
                        ga(() => {
                            // Navigate to url
                            window.location.href = url
                        })

                        return false
                    }
                }
            }
        })
    },
    employment() {
        $('.application-form').each((i, e) => {
            const $form = $(e)
            const jobTitle = $form.data('job-title')
            $form.find('input.positionAppliedFor').val(jobTitle)
        })
    },
    newsletters() {
        // Newsletter section

        $('.newsletter-article')
            .find('.continue')
            .on('click', function (e) {
                const $article = $(this).parent()
                const $expandable = $article.find('.newsletter-blocks-wrapper')
                const $content = $article.find('.newsletter-blocks')

                // toggle class
                $article.toggleClass('is-active')

                // set height to article size
                const height = $content.outerHeight() + 20
                $expandable.css({
                    'max-height': `${height}px`,
                })

                if ($article.hasClass('is-active')) {
                    // allow any height after animation done
                    setTimeout(() => {
                        if ($article.hasClass('is-active')) {
                            $expandable.css({
                                'max-height': 'none',
                            })
                        }
                    }, 300)
                } else {
                    // if collapsing article set max height
                    setTimeout(() => {
                        if (!$article.hasClass('is-active')) {
                            $expandable.css({
                                'max-height': '0',
                            })
                        }
                    }, 100)
                }
            })

        $('.newsletter-sidebar #newsletter-menu').on('click', function (e) {
            const menuparent = $(this).closest('.newsletter-sidebar')
            if (!menuparent.hasClass('is-active')) {
                menuparent.addClass('is-active')
            } else {
                menuparent.removeClass('is-active')
            }
        })

        $('.newsletter-sidebar .category-heading').click(function () {
            const target = $($(this).attr('data-attr'))
            $('html, body').animate(
                {
                    scrollTop: target.offset().top - 200,
                },
                800
            )
            const windowWidth = $(window).width()
            if (windowWidth < 1023) {
                $('.toggle-nav-newsletter').toggleClass('cross')
                $('.newsletter-sidebar').toggleClass('open-sidenav')
            }
        })
    },
    entryCalculator() {
        /* Prep Calculator --------------------- */
        function calculateEnrol(birthYear, birthMonth) {
            // QLD kids start Pre prep at 4 years old, so add 4 to the year they were born
            let startYear = birthYear + 4

            const yearLevels = [
                'Pre Prep',
                'Prep',
                'Year 1',
                'Year 2',
                'Year 3',
                'Year 4',
                'Year 5',
                'Year 6',
                'Year 7',
                'Year 8',
                'Year 9',
                'Year 10',
                'Year 11',
                'Year 12',
            ]
            // students born after june get pushed forward a year
            if (birthMonth > 6) {
                startYear++
            }
            const $resultsContainer = $('.child-results')
            const $resultsTable = $resultsContainer.find('table')
            let resultsHtml = '<tr><th>Year of Entry</th><th>Year</th></tr>'
            for (let i = 0; i < yearLevels.length; i++) {
                if (
                    yearLevels[i] === 'Pre Prep' ||
                    yearLevels[i] === 'Year 4' ||
                    yearLevels[i] === 'Year 7' ||
                    yearLevels[i] === 'Year 10'
                ) {
                    resultsHtml = `${resultsHtml}<tr><td>${startYear}</td><td>${yearLevels[i]}</td>`
                }
                startYear++
            }
            // clear table and render results
            $resultsContainer.show()
            $resultsTable.html('').append(resultsHtml)
        }

        // init datepicker
        const $datepicker = $('.input-group.date')
        $datepicker.datepicker({
            startDate: `01/01/${new Date().getFullYear() - 15}`,
            startView: '2',
            autoclose: true,
            todayHighlight: true,
            format: 'dd/mm/yyyy',
        })
        // listen for datepicker change
        $datepicker.datepicker().on('changeDate', (e) => {
            const childBirthday = moment($datepicker.datepicker('getDate'))
            calculateEnrol(childBirthday.year(), childBirthday.month() + 1)
        })
        /* End Prep Calculator --------------------- */
    },
    lockBg() {
        // lock window position
        document.documentElement.style.overflow = 'hidden'
        document.body.scroll = 'no'
    },
    unlockBg() {
        // unlock window position
        document.documentElement.style.overflow = 'scroll'
        document.body.scroll = 'yes'
    },

    wowo() {
        const wTop = $(window).scrollTop()
        const wHeight = $(window).height()
        const wBottom = wTop + wHeight
        $('.wowo:not(.animated)').each(function () {
            const me = $(this)
            const meTop = me.offset().top
            const meHeight = me.innerHeight()
            const meBottom = meTop + meHeight
            const limitTop = wTop - meHeight
            const limitBottom = wBottom + meHeight
            if (meTop > limitTop && meBottom < limitBottom) {
                me.addClass('animated')
                setTimeout(() => {
                    me.removeClass('wowo')
                }, 1500)
            }
        })
    },

    userback() {
        // const cookieValue = document.cookie
        //     .split('; ')
        //     .find((row) => row.startsWith('adminUserGroup='))
        //     ?.split('=')[1]
        // if (cookieValue === 1) {
        // console.log(cookieValue);
        window.Userback = window.Userback || {}
        Userback.access_token = 'A-KAOWMJMCCue19JyPCT444tKeu'
        ;(function (d) {
            const s = d.createElement('script')
            s.async = true
            s.src = 'https://static.userback.io/widget/v1.js'
            ;(d.head || d.body).appendChild(s)
        })(document)
        // }
    },

    stickyMenu() {
        if ($('.navigation').length) {
            const { body } = document
            const nav = document.querySelector('.navigation')
            const scrollUp = 'menu-stuck'
            const scrollUpNav = 'is-stuck'
            const scrollDown = 'scroll-down'
            let lastScroll = 0

            let width = $(document).width()
            let navOffset = 95

            window.addEventListener('resize', () => {
                width = $(window).width()
            })

            window.addEventListener('scroll', () => {
                const currentScroll = window.pageYOffset
                const scrollLimit = 0
                const scrollValue = window.scrollY

                if ($('body').hasClass('autoscroll')) {
                    return
                }

                if (width <= 1023) {
                    navOffset = 81
                } else if (width < 1215) {
                    navOffset = 140
                } else {
                    navOffset = 161
                }

                // console.log({scrollValue, lastScroll, width, currentScroll, navOffset})

                if (scrollValue >= scrollLimit) {
                    if (currentScroll <= navOffset) {
                        body.classList.remove(scrollUp)
                        body.classList.remove(scrollDown)
                        nav.classList.remove(scrollUpNav)
                        return
                    }
                    if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
                        // down
                        body.classList.remove(scrollUp)
                        nav.classList.remove(scrollUpNav)
                        body.classList.add(scrollDown)
                    } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
                        // up
                        body.classList.remove(scrollDown)
                        body.classList.add(scrollUp)
                        nav.classList.add(scrollUpNav)
                    }
                    lastScroll = currentScroll
                }
            })
        }
    },
    lockScroll() {
        const $html = $('html')
        const $body = $('body')
        const initWidth = $body.outerWidth()
        const initHeight = $body.outerHeight()

        const scrollPosition = [
            self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
            self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop,
        ]
        $html.data('scroll-position', scrollPosition)
        $html.data('previous-overflow', $html.css('overflow'))
        $html.css('overflow', 'hidden')
        window.scrollTo(scrollPosition[0], scrollPosition[1])

        const marginR = $body.outerWidth() - initWidth
        const marginB = $body.outerHeight() - initHeight
        $body.css({
            'margin-right': marginR,
            'margin-bottom': marginB,
        })
    },
    unlockScroll() {
        const $html = $('html')
        const $body = $('body')
        $html.css('overflow', $html.data('previous-overflow'))
        const scrollPosition = $html.data('scroll-position')
        window.scrollTo(scrollPosition[0], scrollPosition[1])

        $body.css({
            'margin-right': 0,
            'margin-bottom': 0,
        })
    },
    navbar() {
        $('.navigation')
            .find('.navbar-burger')
            .on('click', function (e) {
                e.preventDefault()
                const target = $(this).attr('data-target')
                const targetObj = $(`#${target}`)
                const object = $('body')
                if (!object.hasClass('menu-open')) {
                    $(object).addClass('menu-open')
                    targetObj.addClass('is-active')

                    // console.log(target);
                    digistormWeb.lockScroll()
                } else {
                    $(object).removeClass('menu-open')
                    targetObj.removeClass('is-active')
                    digistormWeb.unlockScroll()
                }
            })

        $('.nav-overlay').on('click', () => {
            $('body').removeClass('menu-open')
            $('.offcanvas-trigger').removeClass('is-active')
            $('.offcanvas-navbar').removeClass('is-active')
            digistormWeb.unlockScroll()
        })

        $('.navbar-dropdown, .navbar-dropdown-third').on('click', (e) => {
            e.stopPropagation()
        })
        $('.nav-lower .quick-links .list-heading').on('click', function (e) {
            const menuparent = $(this).closest('.nav-lower')
            if (!menuparent.hasClass('is-active')) {
                menuparent.addClass('is-active')
            } else {
                menuparent.removeClass('is-active')
            }
        })
    },
    search() {
        $('.search-trigger').on('click', (e) => {
            e.preventDefault()

            digistormWeb.lockScroll()

            $('#search-box').stop().fadeIn(300).addClass('show-it')
            const sTime = setTimeout(() => {
                $('body').stop().addClass('modal-open-search')
                $('#search-box').find('.input').stop().focus()
            }, 900)
        })
        $('#search-close').on('click', () => {
            // clearTimeout(sTime);
            $('.modal-open-search').removeClass('modal-open-search')
            digistormWeb.unlockScroll()
            $('#search-box').stop().fadeOut(300).removeClass('show-it')
            $('#search-box').find('.input').stop().blur()
        })
    },
}

function customSlickArrow(_self, loop = true) {
    const $controlwrapper = _self.next('.slick-bottom')
    const slickLength = _self.find('.item').length
    _self.on('init', (slick) => {
        if (slickLength > 1) {
            $controlwrapper.find('.slick-arrow').show()
        }
        $controlwrapper.find('.slick-prev').on('click', () => {
            _self.slick('slickPrev')
        })
        $controlwrapper.find('.slick-next').on('click', () => {
            _self.slick('slickNext')
        })
    })

    if (!loop) {
        $controlwrapper.find('.slick-prev').addClass('slick-disabled')
        _self.addClass('unloop')
        _self.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            const slideCount = slick.slideCount
            if (nextSlide === 0) {
                $controlwrapper.find('.slick-prev').addClass('slick-disabled')
            } else {
                $controlwrapper.find('.slick-prev').removeClass('slick-disabled')
            }
            if (nextSlide === slideCount - 1) {
                $controlwrapper.find('.slick-next').addClass('slick-disabled')
            } else {
                $controlwrapper.find('.slick-next').removeClass('slick-disabled')
            }
        })
    }
}

function carousels() {
    if ($('.introduce .slick').length > 0) {
        $('.introduce .slick').each(function () {
            const _self = $(this)
            const $controlwrapper = _self.next('.slick-bottom')
            const $dotswrapper = $controlwrapper.find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length
            customSlickArrow(_self)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotswrapper,
                arrows: false,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                adaptiveHeight: false,
                fade: true,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: false,
                draggable: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            adaptiveHeight: true,
                        },
                    },
                ],
            })
        })
    }

    if ($('.why-brewster .slick').length > 0) {
        $('.why-brewster .slick').each(function () {
            const _self = $(this)
            const $controlwrapper = _self.next('.slick-bottom')
            const $dotswrapper = $controlwrapper.find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length
            customSlickArrow(_self)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotswrapper,
                arrows: false,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                adaptiveHeight: false,
                fade: true,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: false,
                draggable: false,
            })
        })
    }

    if ($('.activities .slick').length > 0) {
        $('.activities .slick').each(function () {
            const _self = $(this)
            const $controlwrapper = _self.next('.slick-bottom')
            const $dotswrapper = $controlwrapper.find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length

            customSlickArrow(_self)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotswrapper,
                arrows: false,
                infinite: true,
                speed: 500,
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: false,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: true,
                draggable: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            })

            customSlickCloneActive(_self)
        })

        $('body').on('click', '.activities .slick .slick-slide' , function () {
            if ($(window).width() > 1023) {
                if ($(this).hasClass('is-open')) {
                    $(this).removeClass('is-open').parents('.slick').removeClass('is-active')
                } else {
                    $(this).parents('.slick').addClass('is-active')
                    $(this).addClass('is-open').siblings().removeClass('is-open')
                }
            }
        })
    }

    if ($('.news-events .content > .slick').length > 0) {
        $('.news-events .content > .slick').each(function () {
            const _self = $(this)
            const $controlwrapper = _self.next('.slick-bottom')
            const $dotswrapper = $controlwrapper.find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length
            customSlickArrow(_self)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotswrapper,
                arrows: false,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: false,
                draggable: false,
                cssEase: 'ease',
                // asNavFor: '.slider-for'
            })

            _self.find('.item').on('click', function () {
                const index = $(this).parents('.slick-slide').index()
                _self
                    .parents('.news-events')
                    .find('.article-modal-slick')
                    .find('.slick')
                    .slick('slickGoTo', index - 1)
                $('html').css('overflow', 'hidden')
                setTimeout(() => {
                    _self.parents('.news-events').find('.article-modal').addClass('active')
                }, 500)
            })
        })
    }

    if ($('.news-events .article-modal-slick > .slick').length > 0) {
        $('.news-events .article-modal-slick > .slick').each(function () {
            const _self = $(this)
            const $controlwrapper = _self.next('.slick-bottom')
            const $dotswrapper = $controlwrapper.find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length
            customSlickArrow(_self)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotswrapper,
                arrows: true,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: false,
                draggable: true,
                cssEase: 'ease',
                // asNavFor: '.slider-nav'
            })
        })
    }

    if ($('.quote--slider .slick').length > 0) {
        $('.quote--slider .slick').each(function () {
            const _self = $(this)
            const $controlwrapper = _self.next('.slick-bottom')
            const $dotswrapper = $controlwrapper.find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length
            customSlickArrow(_self)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotswrapper,
                arrows: false,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                adaptiveHeight: true,
                fade: true,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: false,
                draggable: false,
            })
        })
    }

    if ($('.inforgraphic .slick').length > 0) {
        $('.inforgraphic .slick').each(function () {
            const _self = $(this)
            const $controlwrapper = _self.next('.slick-bottom')
            const $dotswrapper = $controlwrapper.find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length
            customSlickArrow(_self)
            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotswrapper,
                arrows: false,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: false,
                draggable: false,
            })
        })
    }

    if ($('.link-tiles .slick').length > 0) {
        $('.link-tiles .slick').each(function () {
            const _self = $(this)
            const $controlwrapper = _self.next('.slick-bottom')
            const $dotswrapper = $controlwrapper.find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length
            customSlickArrow(_self)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotswrapper,
                arrows: false,
                infinite: true,
                speed: 500,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: false,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: false,
                draggable: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            })
        })
    }

    if ($('.team-slider .slick').length > 0) {
        $('.team-slider .slick').each(function () {
            const _self = $(this)
            const $controlwrapper = _self.next('.slick-bottom')
            const $dotswrapper = $controlwrapper.find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length
            customSlickArrow(_self)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotswrapper,
                arrows: false,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: false,
                draggable: false,
            })
        })
    }
}

function clickFunction() {
    $('.staff-item--content').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active').next().stop().slideUp(250)
        } else {
            const active = $(this).closest('.staff-block').find('.staff-item--content.active')
            active.removeClass('active').next().stop().slideUp(250)
            $(this).addClass('active').next().stop().slideDown(250)
        }
    })

    $('body').on('click', (e) => {
        const _con = $('.staff-items')
        if (!_con.is(e.target) && _con.has(e.target).length === 0) {
            _con.find('.staff-item--content.active').next().stop().slideUp(250)
            _con.find('.staff-item--content.active').removeClass('active')
        }
    })

    $('.explore').on('click', function () {
        $('body,html').animate(
            {
                scrollTop: $(this).parents('.banner').offset().top + $(this).parents().height(),
            },
            500
        )
    })

    $('.back-to-top').on('click', () => {
        $('body,html').animate(
            {
                scrollTop: 0,
            },
            500
        )
    })

    $('.selection__title').on('click', function (e) {
        e.preventDefault()
        $(this).toggleClass('is-open').siblings('.selection__dropdown').stop()
            .slideToggle(250)
        $(this).closest('.selection').toggleClass('is-open')
        $(this).closest('.selection').siblings().removeClass('is-open')
        $(this).closest('.selection').siblings().find('.selection__title')
            .removeClass('is-open')
        $(this).closest('.selection').siblings().find('.selection__dropdown')
            .slideUp(250)

        $(this).closest('.banner').toggleClass('is-open')
    })

    $(document).on('click', (e) => {
        const container = $('.selection')
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.selection__dropdown').stop().slideUp(250)
            container.removeClass('is-open')
            container.find('.selection__title').removeClass('is-open')

            container.closest('.banner').removeClass('is-open')
        }
    })


    $('.hoz-accordion .item .title').on('click', function () {
        const t = $(this).closest('.item')
        $(t).toggleClass('is-active').siblings().removeClass('is-active')
    })

    $('.hoz-accordion .item .close-accordion').on('click', function () {
        const t = $(this).closest('.item')
        $(t).removeClass('is-active')
    })

    $('.timeline .item .img').on('click', function (e) {
        e.preventDefault()
        const modalId = $(this).attr('data-modal-id')
        const modal = $(`#${modalId}`)
        modal.addClass('active')
        $('html').css('overflow', '')
    })

    $('.close-timeline-modal, .timeline-modal-background').click(function () {
        $(this).parents('.timeline-modal').removeClass('active')
    })

    $('.news-events .item').on('click', (e) => {
        // e.preventDefault()
        // const modalId = $(this).attr('data-modal-id')
        // const modal = $(`#${modalId}`)
        // modal.addClass('active')
    })
    // $('.news-events .item a').on('click', (e) => {
    //     e.stopPropagation()
    // })

    $('.modal-tiles .tile').on('click', function (e) {
        const modalId = $(this).attr('data-modal-id')
        if (modalId) {
            e.preventDefault()
            const modal = $(`#${modalId}`)
            modal.addClass('active')
        }
    })

    $('.home-team-slider .play-modal-btn').on('click', function (e) {
        e.preventDefault()
        const modalId = $(this).attr('data-modal-id')
        const modal = $(`#${modalId}`)
        modal.addClass('active')
    })

    $('.close-article-modal, .article-modal-background').click(function () {
        $(this).parents('.article-modal').removeClass('active')
        $('html').css('overflow', '')
    })

    let menuState = ''

    $('#happening').on('click', () => {
        $('.happening').addClass('is-active')
        $('html').css('overflow', 'hidden')
        $('body').addClass('happening-open')

        // if ($('body').hasClass('menu-stuck')) {
        //     menuState = 'stuck'
        // } else if ($('body').hasClass('scroll-down')) {
        //     menuState = 'down'
        //     $('body').addClass('menu-stuck').removeClass('scroll-down')
        // } else {
        //     $('body').addClass('menu-stuck')
        // }
    })

    $('.close-happening').on('click', () => {
        $('.happening').removeClass('is-active')
        $('body').removeClass('happening-open')
        // if (menuState === 'down') {
        //     $('body').removeClass('menu-stuck').addClass('scroll-down')
        // } else if (menuState === '') {
        //     $('body').removeClass('menu-stuck')
        // }

        if (!$('body').is('[class$="open"]')) {
            $('html').css('overflow', '')
        }
    })

    $('.happening-nav button').on('click', function (e) {
        e.preventDefault()
        const me = $(this).parents('.item')
        const index = me.index()
        const content = $(this).parents('.happening-nav').next('.happening-panel').find('.panel').eq(index)
        me.addClass('is-active').siblings().removeClass('is-active')
        content.addClass('is-active').siblings().removeClass('is-active')
    })

    $('.why-brewster .item .img').on('click', function () {
        const me = $(this).closest('.slick')
        me.toggleClass('is-active')
    })

    /* global item */
    $('.schools .item button').on('click', function () {
        const item = $(this).closest('.item')
        const index = item.index()
        const cont = item.closest('.schools').find('.tabs-body').find('.item').eq(index)

        if ((index !== 0 || (index === 0 && !item.hasClass('is-active'))) && $(window).width() > 1023) {
            item.toggleClass('is-active').siblings().removeClass('is-active')
            cont.toggleClass('is-active').siblings().removeClass('is-active')
        }

        if ($(window).width() <= 1023) {
            item.toggleClass('is-active').siblings().removeClass('is-active')
        }
    })

    $('.map .labels .item button').on('click', function () {
        const $me = $(this).closest('.item')
        const $index = $me.index()
        const $cont = $me.parents('.map-content').find('.items')
        const $text = $me.parents('.map').find('.text-overlay')
        $me.addClass('is-active').siblings().removeClass('is-active')
        $text.eq($index).addClass('is-active').siblings().removeClass('is-active')
        $cont.find('.item').eq($index).addClass('is-active').siblings().removeClass('is-active')
        if ($index === 1) {
            $me.parents('.map-content').addClass('is-active')
        } else {
            $me.parents('.map-content').removeClass('is-active')
        }
    })
}

function roundText() {
    const magnets = document.querySelectorAll('.round-text')
    const strength = 50
    function moveMagnet(event) {
        const magnetButton = event.currentTarget
        const bounding = magnetButton.getBoundingClientRect()
        gsap.to(magnetButton, 1, {
            x: ((event.clientX - bounding.left) / magnetButton.offsetWidth - 0.5) * strength,
            y: ((event.clientY - bounding.top) / magnetButton.offsetHeight - 0.5) * strength,
            ease: Power4.easeOut,
        })
    }

    magnets.forEach((magnet) => {
        magnet.addEventListener('mousemove', moveMagnet)
        magnet.addEventListener('mouseout', (event) => {
            gsap.to(event.currentTarget, 1, {
                x: 0,
                y: 0,
                ease: Power4.easeOut,
            })
        })
    })
}

function categoriesNav() {
    $('.categories-nav p').on('click', function () {
        $(this).next().stop().slideToggle(250)
        $(this).parents('.categories-nav').toggleClass('is-active')
    })
    $('.categories-nav li').on('click', function () {
        const me = $(this)
        me.parents('.categories-nav').removeClass('is-active').find('p').html(me.text())
        me.parents('ul').stop().slideToggle(250)
        me.addClass('is-active').siblings().removeClass('is-active')
    })
    $('body').on('click', (e) => {
        const _con = $('.categories-nav')
        if (!_con.is(e.target) && _con.has(e.target).length === 0) {
            $('.categories-nav ul').stop().slideUp(250)
            _con.removeClass('is-active')
        }
    })
}

function initWebsiteScripts() {
    window.MultiselectDropdown = MultiselectDropdown
    digistormWeb.init()
    $('body').addClass('animated-wowo-control')

    // custom MTC scripts
    carousels()
    clickFunction()
    roundText()
    categoriesNav()

    $('.slick').each(function () {
        const count = $(this).next('.slick-bottom').find('.slick-dots').find('li').length
        $(this).next('.slick-bottom').find('.slick-dots').attr('style', `--index:1;--count:${count};`)
    })
    $('.slick').on('beforeChange', function (event, slickElement, currentSlide, nextSlide) {
        console.log(slickElement.slideCount)
        const count = slickElement.slideCount
        if (nextSlide === count) {
            nextSlide = 0
        }
        $(this)
            .next('.slick-bottom')
            .find('.slick-dots')
            .attr('style', `--index:${parseInt(nextSlide + 1, 10)};--count:${count};`)
    })
}

// wait for vue to mount before attaching event listeners
// any event listeners attached before vue mounts will get deleted
document.addEventListener('ds-components-mounted', (e) => {
    initWebsiteScripts()
})

if (window.dsComponentsMounted) {
    initWebsiteScripts()
}

$(window).scroll(() => {
    digistormWeb.wowo()

    if ($('.article-content').length > 0) {
        if ($(window).scrollTop() > $('.article-content').offset().top) {
            $('body').addClass('breadcrumb-is-stuck')
        } else {
            $('body').removeClass('breadcrumb-is-stuck')
        }
    }
})

$(window).on('load', () => {
    digistormWeb.wowo()
})
